import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sid = m[1];
    api.post("/auth/session", null, { headers: { "X-Session-ID": sid } })
      .then(r => { setUser(r.data); navigate("/account", { replace: true }); })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return (
    <main className="pt-40 pb-32 text-center" data-testid="auth-callback">
      <p className="font-serif text-3xl text-[#A39E8A] mb-4">Autentificare...</p>
      <div className="h-1 w-40 mx-auto shimmer-gold" />
    </main>
  );
}
